import * as React from "react";
import { memo } from "react";

import { STATUS_COLOR, TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Box, Group, NumberInput, Text } from "@mantine/core";

import {
  PriceDropTimePeriod,
  PriceDropTimePeriodInput,
  TimeUnit,
} from "apollo/graphql.generated";

type Props = {
  value?: PriceDropTimePeriod[] | null;
  onChange: (value?: PriceDropTimePeriodInput[] | null) => void;
  error?: string | null;
  disabled?: boolean;
};

const DutchAuctionsPriceDropIntervalInput: React.FC<Props> = ({
  error,
  onChange,
  value,
  disabled,
}) => {
  const handleOnEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const getPriceDropInterval = (hours: number, minutes: number) => [
    {
      unit: TimeUnit.HOURS,
      value: hours,
    },
    {
      unit: TimeUnit.MINUTES,
      value: minutes,
    },
  ];

  const getPeriodValue = (
    unit: TimeUnit,
    drops?: PriceDropTimePeriod[] | null
  ) => drops?.find((period) => period.unit === unit)?.value || 0;

  const hours = getPeriodValue(TimeUnit.HOURS, value);
  const minutes = getPeriodValue(TimeUnit.MINUTES, value);

  return (
    <Box>
      <Text component="label" size="sm">
        Price drop interval
      </Text>
      <Text size="sm">
        Choose the interval at which the token price will drop
      </Text>
      <Group mt={8} spacing={20} grow>
        <NumberInput
          onKeyDown={handleOnEnter}
          onChange={(inputValue) =>
            onChange(getPriceDropInterval(inputValue || 0, minutes))
          }
          precision={0}
          value={hours}
          rightSectionWidth={99}
          rightSection={
            <Text color={TEXT_COLOR.PLACEHOLDER} size="sm">
              Hours
            </Text>
          }
          min={0}
          step={0}
          removeTrailingZeros={true}
          disabled={disabled}
        />
        <NumberInput
          onKeyDown={handleOnEnter}
          onChange={(inputValue) =>
            onChange(getPriceDropInterval(hours, inputValue || 0))
          }
          precision={0}
          value={minutes}
          rightSectionWidth={99}
          rightSection={
            <Text color={TEXT_COLOR.PLACEHOLDER} size="sm">
              Minutes
            </Text>
          }
          min={0}
          step={0}
          removeTrailingZeros={true}
          disabled={disabled}
        />
      </Group>
      <Text color={STATUS_COLOR.ERROR} size="xs" mt="xs">
        {error}
      </Text>
    </Box>
  );
};

export default memo(DutchAuctionsPriceDropIntervalInput);
